import { useSelector } from "react-redux";
import { CSSProperties } from "react";
import useWindowDimensions from "hooks/useWindowDimensions";

export default (props: any): any => {
    const splitStyles: CSSProperties = {};
    const splitClasses: string[] = [];

    const { width } = useWindowDimensions();
    const page = useSelector(state => state.page.content);

    const currentBlockIndex = page?.blocks?.findIndex(x => x?.contentUdi === props.contentUdi) ?? 0;
    const nextBlock = page?.blocks && page?.blocks.length >= (currentBlockIndex + 1) ? page?.blocks?.[currentBlockIndex + 1] : undefined;

    // Checks if "THIS" block has a splitBackground setting, and go UP
    if (props && props.settings?.splitBackground === "Small") {
        splitClasses.push(`moveup--${props.settings.splitBackground}`);
    }
    else if (props && props.settings?.splitBackground === "Large") {
        splitClasses.push(`moveup--${props.settings.splitBackground}`);
    }

    // Check if NEXT block has setting, and add spacing
    if (nextBlock && nextBlock.settings?.splitBackground === "Small") {
        splitStyles["--extra-block-padding-bottom"] = width >= 1024 ? "20rem" : "7rem";
    }
    else if (nextBlock && nextBlock.settings?.splitBackground === "Large") {
        splitStyles["--extra-block-padding-bottom"] = width >= 1024 ? "30rem" : "12rem";
    }

    return { splitClasses, splitStyles };
};